import { Tab } from "@mui/base";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  TableHead,
  Typography,
  Button,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import moment from "moment";
import useStyles from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { gql, useLazyQuery } from "@apollo/client";
import { CustomCircularProgress, NoData } from "../../hoc/CustomComponents";
import CloudDownloadIcon from "@mui/icons-material/CloudDownloadOutlined";
import IconButton from "@mui/material/IconButton";
import { useMutation } from "@apollo/client";
import axios from "axios";
import FileSaver from "file-saver";


const GET_Transaction_BY_LOGINID = gql`
  query($login_id : Int){
    getTransactionsByLoginId(login_id: $login_id){
        Date
        vin
        transactions
        amount
        transaction_id
        transaction_reason
        balance 
      }
  }
`;

const DOWNLOAD_TRANSACTION_EXCEL=gql `
  mutation($downloadFor:String!, $loginId:Int) {
    excelFileDownload(
      downloadFor:$downloadFor,
      loginId:$loginId
    ){
      downloadUrl,
      __typename
    }
  }
`;

const ViewTransactions = ({
  open,
  columns,
  loginId,
  closeTransactions,
}) => {
  const classes = useStyles();
  let [next, setNext] = useState(0);
  const [transaction, setTransaction] = useState();

  const [
    TransactionDetails,
    { error: error, loading: loading, data: Details },
  ] = useLazyQuery(GET_Transaction_BY_LOGINID, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted: async (result) => {
      console.log("getTransactionsByLoginId;;",result)
      setTransaction(result?.getTransactionsByLoginId || []);
    },
  });
  
  useEffect(() => {
    TransactionDetails({
      variables: {
        login_id: loginId,
      },
    });
  }, [loginId]);

  const [excelFileDownload, {loading:excelLoading}]=useMutation(
  DOWNLOAD_TRANSACTION_EXCEL,
  {
    fetchPolicy:"network-only",
    onError:({graphQlErrors,networkError}) => {
      if(networkError) {
        alert("Network Error")
      }

      if(graphQlErrors) {
        graphQlErrors.forEach(({message}) => {
           alert(message)
        });
    }
  },
  onCompleted :async(result) => {
    const downloadUrl=result?.excelFileDownload?.downloadUrl;
    if(!downloadUrl) {
      alert('No transaction details are available')
      return;
    }

    const res =await axios ({
      url:downloadUrl,
      method:"GET",
      headers:{
        Accept:"application/vnd.ms-excel"
      },
      responseType:"blob",
    });

    FileSaver.saveAs(
      new Blob([res.data]),
      "Transaction_Details.xlsx"
    )
   }
  }
 );

 const handleDownloadExcel = () => {
  excelFileDownload({
    variables:{
      downloadFor:"TRANSACTION_DETAILS",
      loginId:loginId
    }
  })
 }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"md"}
      aria-labelledby="max-width-dialog-title"
      disableEscapeKeyDown={true}
    >

     <DialogTitle>
        <Grid container alignItems="center">
           {/* Left side: Title + Download */}
            <Grid item xs={10}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <Typography variant="h6">
                    Transaction Details
                  </Typography>
                </Grid>

                <Grid item>
                  <Tooltip title="Download Excel">
                    <IconButton
                      onClick={handleDownloadExcel}
                      size="small"
                      disabled={excelLoading}
                    >
                      <CloudDownloadIcon
                        style={{ fill: "#57B793", fontSize: 30 }}/>
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>

            {/* Right side: Close button */}
            <Grid item xs={2} style={{ textAlign: "right" }}>
              <IconButton onClick={closeTransactions}>
                <CloseIcon style={{ fill: "#2b2924" }} />
              </IconButton>
            </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            {loading ? (
              <CustomCircularProgress />
            ) : transaction?.length > 0 ? (
              <TableContainer style={{ height: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          align="center"
                          style={{
                            minWidth: column.minWidth,
                            font: "normal normal 600 15px/20px Nunito Sans",
                            backgroundColor: "#faf8f7",
                          }}
                          className={classes.tableHead}
                        >
                          {column.name}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {transaction.map((row, index) => {
                      return (
                        <TableRow>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {next + (index + 1)}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.Date ? (moment.unix(row.Date).format("DD-MM-YYYY HH:mm:ss")) : "NA"}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.vin ? row.vin : "NA"}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {/* {row.transactions ? row.transactions : "NA"} */}
                            {row.transactions && row.transactions == 'payment_cancelled' ? 'Cancelled'
                            : row.transactions == 'payment_failed' ? 'Failed'
                            : row.transactions == 'Added Money' ||  row.transactions == 'AIS-140 Request' || row.transactions == 'AIS140 After Market'
                            ? 'Success' : 'Error'}

                          </TableCell>
                         <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.amount ? row.amount : "NA"}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.transaction_id ? row.transaction_id : "NA"}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.transaction_reason ? row.transaction_reason : "NA"}
                          </TableCell>
                          <TableCell
                            align="center"
                            className={classes.tableContent}
                          >
                            {row.balance ? row.balance : "NA"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ViewTransactions;
